import { Engine } from "@courses-pm2/api/src/ts/utils";

export type ElementModelData = {
    portalId: string;
    isScrambled: boolean;
    engine?: Engine;
};

/**
 * Each component will need to implement an extension of the ElementModel, which
 * will be used to describe the content that's supposed to be rendered.
 */
export abstract class ElementModel {
    /**
     * Specifies the id of the portal that this element belongs to, so that
     * clients can easily determine where it's originating from.
     */
    public readonly portalId: string;

    /**
     * Specifies whether or not this content should be displayed to the user in
     * a scrambled form.
     */
    public readonly isScrambled: boolean;

    /**
     * Will contain a reference to the engine that's used to power rendering of
     * models within the current application.
     */
    protected readonly engine?: Engine;

    /**
     * Cache reference to the engine associated with this model when it's
     * constructed.
     */
    constructor(initial: ElementModelData) {
        this.portalId = initial.portalId;
        this.isScrambled = initial.isScrambled;
        this.engine = initial.engine;
    }

    /**
     * Helper that'll return an absolute url to a preview image that's
     * representative of the actual element content.
     */
    public abstract getPreviewImageUrl(): Promise<string | undefined>;

    /**
     * Helper that'll return a text extract from the component, that can be used
     * as a preview of sorts.
     */
    public abstract getPreviewText(): string | undefined;

    /**
     * Extract the raw text content of the element, and calculate how many
     * standard pages it translates to.
     */
    public abstract getStandardPageCount(): number;
}
